import type { Command } from './types';
import { useEditorStore } from '@/store/editorStore';

export const commentCommands: Command[] = [
  {
    id: 'comments.open',
    label: 'Open Comments',
    category: 'edit',
    canExecute: (ctx) => ctx.editorState.selectedNodeIds.length === 1,
    execute: (ctx) => {
      const store = useEditorStore.getState();
      const nodeId = ctx.editorState.selectedNodeIds[0];
      if (!nodeId) return;
      if (store.commentPanelNodeId === nodeId) {
        store.closeCommentPanel();
      } else {
        store.openCommentPanel(nodeId);
      }
    },
  },
  {
    id: 'comments.close',
    label: 'Close Comments',
    category: 'edit',
    canExecute: () => useEditorStore.getState().commentPanelNodeId !== null,
    execute: () => {
      useEditorStore.getState().closeCommentPanel();
    },
  },
];
